/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlSoftDeleteUserRequest
 */
export interface ControlSoftDeleteUserRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlSoftDeleteUserRequest
     */
    reason?: string;
}

/**
 * Check if a given object implements the ControlSoftDeleteUserRequest interface.
 */
export function instanceOfControlSoftDeleteUserRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlSoftDeleteUserRequestFromJSON(json: any): ControlSoftDeleteUserRequest {
    return ControlSoftDeleteUserRequestFromJSONTyped(json, false);
}

export function ControlSoftDeleteUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSoftDeleteUserRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
    };
}

export function ControlSoftDeleteUserRequestToJSON(value?: ControlSoftDeleteUserRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reason': value.reason,
    };
}

